/** Presentation hints from the verified server session; the HttpOnly cookie authenticates requests. */
let identity: { telegramId: number; csrfToken: string } | null = null;

export function setBrowserSession(value: typeof identity): void { identity = value; }
export function getBrowserTelegramId(): number | null { return identity?.telegramId ?? null; }
export function getBrowserCSRF(): string | null { return identity?.csrfToken ?? null; }
export const browserSessionInvalidated = 'autohero:browser-session-invalidated';
export function invalidateBrowserSession(): void {
  if (!identity) return;
  identity = null;
  window.dispatchEvent(new Event(browserSessionInvalidated));
}

export interface BrowserSession {
  authenticated: boolean;
  telegramId: number | null;
  csrfToken: string;
  telegramBotUsername: string;
}

export async function browserSessionRequest(action: 'session' | 'telegram' | 'logout', options: { signal?: AbortSignal; csrfToken?: string; payload?: unknown } = {}): Promise<BrowserSession> {
  const response = await fetch(`/api/v1/auth/browser/${action}`, {
    method: action === 'session' ? 'GET' : 'POST',
    credentials: 'same-origin', cache: 'no-store', signal: options.signal,
    headers: { 'Content-Type': 'application/json', ...(options.csrfToken ? { 'X-Game-CSRF': options.csrfToken } : {}) },
    ...(options.payload === undefined ? {} : { body: JSON.stringify(options.payload) }),
  });
  if (!response.ok) throw new Error('Telegram login unavailable');
  const session = await response.json() as BrowserSession;
  if (typeof session.authenticated !== 'boolean' || typeof session.csrfToken !== 'string' ||
      typeof session.telegramBotUsername !== 'string' ||
      (session.authenticated && (!Number.isSafeInteger(session.telegramId) || session.telegramId! <= 0))) {
    throw new Error('Invalid login response');
  }
  return session;
}
